import { Injectable } from '@angular/core';

import { Http, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { SettingsService } from '../common/settings.service';
import Enums from '../../utils/enums';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { HttpClient } from 'selenium-webdriver/http';


@Injectable()
export class AuthService {
    authToken: any;
    user: any;


    constructor(
        private http: HttpClient,
        private settings: SettingsService,
        private router: Router
    ) { }

    authenticateUser(user): any {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post(this.settings.serverMain + 'Main/AuthorizeWeb', user, { headers: headers });
    }

    storeData(token, user) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        this.authToken = token;
        this.user = user;
    }

    getUserToken() {
        return localStorage.getItem('token');
    }

    loadUserData() {
        return JSON.parse(localStorage.getItem('user'));
    }

    getUserLoginRole() {
        const user = JSON.parse(localStorage.getItem('user'));

        if (user) {
            return user.loginRole;
        } else {
            return null;
        }
    }

    checkSession() {
        const headers = new HttpHeaders({
            'Authorization': this.getUserToken(),
            'LoginRole': this.getUserLoginRole()
        });

        return this.http.get(`${this.settings.serverMain}Main/CheckSession`, { headers: headers });
    }

    logout() {
        const headers = new HttpHeaders({
            'Authorization': this.getUserToken(),
            'LoginRole': this.getUserLoginRole()
        });
        this.localLogout();

        return this.http.get(this.settings.serverMain + 'Main/Logout', { headers: headers });
    }

    localLogout() {
        this.router.navigate(['/login']);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }
}
